// extracted by mini-css-extract-plugin
export default {"detail":"JobDetail_detail__nhI6x"};